import React from "react";
import { CheckboxWithLabel } from "formik-material-ui";
import { FastField } from "formik";

import I18nText from "../../../../../../elements/I18nText";
import BubbleHelpFieldWrapper from "../../../../../../elements/FormField/BubbleHelpFieldWrapper";

const Watchdog = () => (
  <BubbleHelpFieldWrapper id="devices.edit.watchdog">
    <FastField
      component={CheckboxWithLabel}
      type="checkbox"
      name="watchdogEnabled"
      color="primary"
      Label={{
        label: (
          <I18nText>devices.settings.configuration.watchdogEnabled</I18nText>
        )
      }}
    />
  </BubbleHelpFieldWrapper>
);

export default Watchdog;
